<template>
  <Card>
    <div class="tablighat-banner">
      <div v-if="image" class="small-12 columns medium-3 text-center">
        <img :src="image" class="tablighat-banner__image" />
      </div>
      <div class="columns">
        <div class="tablighat-banner__text">
          <h3>{{ title }}</h3>
          <p>
            <span v-dompurify-html="description" />
            <a
              v-if="link"
              class="tablighat-banner__link"
              target="_blank"
              :href="link"
            >
              {{ $t('LEARN_MORE') }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@@/common/Card';

export default {
  name: 'AdBanner',
  components: {
    Card,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.tablighat-banner {
  display: flex;
  flex-wrap: wrap;
  text-align: justify;

  &__link {
    color: $blue;

    @include breakpoint(medium down) {
      display: block;
      margin-top: $global-margin / 2;
    }
  }

  &__image {
    margin-bottom: $global-margin;

    @include breakpoint(small only) {
      max-width: 80%;
      max-height: $global-margin * 10;
    }
  }

  &__text {
    p {
      margin-top: $global-margin * 3/2;
    }
  }
}
</style>
